import type { BlogPostMeta } from "./types";

export type BlogAuthor = {
  id: string;
  name: string;
  /** Short line for bylines / schema */
  jobTitle: string;
};

export const AUTHORS: BlogAuthor[] = [
  {
    id: "holiday-malepe",
    name: "Holiday Malepe",
    jobTitle: "Lead research & inventory analysis",
  },
  {
    id: "desiree-moeng",
    name: "Desiree Moeng",
    jobTitle: "Operations research & field notes",
  },
  {
    id: "maki-k-malepe",
    name: "Maki K Malepe",
    jobTitle: "Supply chain & working-capital analysis",
  },
  {
    id: "tiisetso-p-malepe",
    name: "Tiisetso P Malepe",
    jobTitle: "Retail systems & compliance research",
  },
];

function stableHash(s: string): number {
  let h = 0;
  for (let i = 0; i < s.length; i++) h = Math.imul(31, h) + s.charCodeAt(i);
  return Math.abs(h);
}

/**
 * Deterministic author per article. Holiday is weighted heavier as primary researcher.
 * Override with `meta.authorId` when set in the registry.
 */
export function resolveArticleAuthor(meta: BlogPostMeta): BlogAuthor {
  if (meta.authorId) {
    const a = AUTHORS.find((x) => x.id === meta.authorId);
    if (a) return a;
  }
  const h = stableHash(meta.slug) % 10;
  // 50% Holiday, ~16.7% each for the other three
  const idx = h < 5 ? 0 : 1 + ((h - 5) % 3);
  return AUTHORS[idx]!;
}
